import { createActionConst } from '../../../utils/action.utils';

const MEETING_REPORT_NAMESPACE = 'MEETING_REPORT';

export const STORE_MEETING_REPORT = createActionConst(MEETING_REPORT_NAMESPACE, 'STORE_MEETING_REPORT');
export const CLEAR_MEETING_REPORT = createActionConst(MEETING_REPORT_NAMESPACE, 'CLEAR_MEETING_REPORT');
